// THE RING'S GENOME SOLVE IN THE CLIENT WORKER POOL (R8c5; client/src/pool.js,
// an op of poolwork.js OPS).
//
//   genome.params {rec, key, table?}
//                 genometex.js genomeTexParams(rec, key, table) of one genome
//                 record (surface/genome.json classes[key]) — the heavy
//                 texel-independent solve (~140 ms a record on a desktop main
//                 thread: R8's 1,691 ms over 12 tasks under gen.ring). table:
//                 genome_noise.json (undefined: genometex's own import — what
//                 ringgen's world holds). The result is the main thread's
//                 value, deep and bit-equal (plain numbers and arrays; float64
//                 survives the structured clone): ringgen.js hands it to
//                 ringref.js ringSetRecord. Its one typed array, gz (the
//                 table's Gaussianising curve, Float32Array), is genometex's
//                 per-table cache shared by every record — a COPY is
//                 transferred (moving the cached one would detach it for this
//                 worker's next job).
//
// Pure + DOM-free (the worker bundle: poolwork.js imports this module).
import { genomeTexParams } from './genometex.js';

function genomeParams({ rec, key, table }) {
  const P = genomeTexParams(rec, key, table);
  const gz = P.gz.slice();
  return { result: { ...P, gz }, transfer: [gz.buffer] };
}

// poolwork.js OPS (spread in)
export const GENOME_OPS = {
  'genome.params': genomeParams,
};
